import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  accordionVariant: 'aligned',
  sortBonusItemsFirst: true
} satisfies CheckoutConfig['cartContainer']
